import{jsx as i}from"react/jsx-runtime";import"react";function r(r){var t=r.id,e=r.description;return e?i("string"==typeof e?"p":"div",{id:t,className:"field-description",children:e}):null}export{r as default};
